import DesignSystemComponents from "@core/components/design-system";

export default {
  install(vueInstance) {
    // register global components
    DesignSystemComponents.forEach((component) => vueInstance.component(component.name, component.config));
  },
};
